const STATE_HW_CODES: Record<string, number> = {
  WA:  906,
  ACT: 1611,
  NSW: 1612,
  VIC: 1613,
  QLD: 1614,
  SA:  1615,
  TAS: 1617,
};

export function getHWCodeByState(state: string): number | null {
  return STATE_HW_CODES[state.toUpperCase()] ?? null;
}

// Array of postcode ranges for Solar Water Heaters
export const solarWaterHeaterZones = [
  { from: 800, to: 854, zone: 1 },
  { from: 860, to: 860, zone: 2 },
  { from: 862, to: 862, zone: 1 },
  { from: 870, to: 875, zone: 2 },
  { from: 880, to: 886, zone: 1 },
  { from: 2000, to: 2914, zone: 3 },
  { from: 3000, to: 3381, zone: 4 },
  { from: 3384, to: 3384, zone: 3 },
  { from: 3385, to: 3387, zone: 4 },
  { from: 3388, to: 3396, zone: 3 },
  { from: 3400, to: 3413, zone: 4 },
  { from: 3414, to: 3424, zone: 3 },
  { from: 3427, to: 3451, zone: 4 },
  { from: 3453, to: 3465, zone: 3 },
  { from: 3467, to: 3469, zone: 4 },
  { from: 3472, to: 3520, zone: 3 },
  { from: 3521, to: 3522, zone: 4 },
  { from: 3523, to: 3649, zone: 3 },
  { from: 3658, to: 3658, zone: 4 },
  { from: 3659, to: 3709, zone: 3 },
  { from: 3711, to: 3723, zone: 4 },
  { from: 3725, to: 3749, zone: 3 },
  { from: 3750, to: 3898, zone: 4 },
  { from: 3900, to: 3900, zone: 3 },
  { from: 3902, to: 3996, zone: 4 },
  { from: 4000, to: 4419, zone: 3 },
  { from: 4420, to: 4420, zone: 1 },
  { from: 4421, to: 4428, zone: 3 },
  { from: 4454, to: 4454, zone: 1 },
  { from: 4455, to: 4465, zone: 3 },
  { from: 4467, to: 4468, zone: 1 },
  { from: 4470, to: 4474, zone: 2 },
  { from: 4477, to: 4477, zone: 1 },
  { from: 4478, to: 4482, zone: 2 },
  { from: 4486, to: 4488, zone: 3 },
  { from: 4489, to: 4493, zone: 2 },
  { from: 4494, to: 4615, zone: 3 },
  { from: 4620, to: 4724, zone: 1 },
  { from: 4725, to: 4725, zone: 2 },
  { from: 4726, to: 4726, zone: 1 },
  { from: 4727, to: 4731, zone: 2 },
  { from: 4732, to: 4735, zone: 1 },
  { from: 4736, to: 4736, zone: 2 },
  { from: 4737, to: 4824, zone: 1 },
  { from: 4825, to: 4830, zone: 2 },
  { from: 4849, to: 4895, zone: 1 },
  { from: 5000, to: 5214, zone: 3 },
  { from: 5220, to: 5223, zone: 4 },
  { from: 5231, to: 5261, zone: 3 },
  { from: 5262, to: 5263, zone: 4 },
  { from: 5264, to: 5270, zone: 3 },
  { from: 5271, to: 5291, zone: 4 },
  { from: 5301, to: 6256, zone: 3 },
  { from: 6258, to: 6262, zone: 4 },
  { from: 6271, to: 6317, zone: 3 },
  { from: 6318, to: 6338, zone: 4 },
  { from: 6341, to: 6341, zone: 3 },
  { from: 6343, to: 6348, zone: 4 },
  { from: 6350, to: 6353, zone: 3 },
  { from: 6355, to: 6357, zone: 4 },
  { from: 6358, to: 6395, zone: 3 },
  { from: 6396, to: 6398, zone: 4 },
  { from: 6401, to: 6438, zone: 3 },
  { from: 6440, to: 6440, zone: 2 },
  { from: 6442, to: 6443, zone: 3 },
  { from: 6445, to: 6452, zone: 4 },
  { from: 6460, to: 6640, zone: 3 },
  { from: 6642, to: 6725, zone: 2 },
  { from: 6726, to: 6743, zone: 1 },
  { from: 6751, to: 6799, zone: 2 },
  { from: 7000, to: 7470, zone: 4 }
];

// Utility function to get zone by postcode
export function getSolarWaterHeaterZone(postcode: number): number | null {
  const range = solarWaterHeaterZones.find(r => postcode >= r.from && postcode <= r.to);
  return range ? range.zone : null; // null if postcode not in list
}

// Array of postcode ranges mapping to location numbers
export const postcodeLocationRanges = [
  { from: 800,  to: 899,  loc: 6 },
  { from: 2000, to: 2258, loc: 24 },
  { from: 2259, to: 2335, loc: 26 },
  { from: 2336, to: 2599, loc: 24 },
  { from: 2600, to: 2699, loc: 1 },
  { from: 2700, to: 2900, loc: 24 },
  { from: 2901, to: 2999, loc: 1 },
  { from: 3000, to: 3099, loc: 21 },
  { from: 3100, to: 3999, loc: 29 },
  { from: 4000, to: 4999, loc: 15 },
  { from: 5000, to: 5999, loc: 25 },
  { from: 6000, to: 6099, loc: 5 },
  { from: 6100, to: 6217, loc: 7 },
  { from: 6218, to: 6319, loc: 30 },
  { from: 6320, to: 6398, loc: 31 },
  { from: 6399, to: 6999, loc: 5 },
  { from: 7000, to: 7999, loc: 21 },
];

export function getLocationByPostcode(postcode: number): number | null {
  const range = postcodeLocationRanges.find(r => postcode >= r.from && postcode <= r.to);
  return range ? range.loc : null;
}

const stockData: { [key: string]: { [key: number]: { quantity: number; price: number } } } = {
  "H-PASHW015-270LD-R290": {
    1: { quantity: 13, price: 455 },
    2: { quantity: 12, price: 420 },
    3: { quantity: 15, price: 525 },
    4: { quantity: 16, price: 560 },
    5: { quantity: 16, price: 560 }
    // fill in based on B35 row R–AA
  },
  "H-PASHW008-180LD-R290": {
    1: { quantity: 12, price: 420 },
    2: { quantity: 11, price: 385 },
    3: { quantity: 14, price: 490 },
    4: { quantity: 14, price: 490 },
    5: { quantity: 14, price: 490 }
    // fill in based on B36 row R–AA
  }
};


export function getSTCValues(postcode: number, stockCode: string) {
  const zone = getSolarWaterHeaterZone(Number(postcode));
  if (!zone) return { zone: null, quantity: null, price: null };

  const data = stockData[stockCode];
  if (!data || !data[zone]) {
    return { zone, quantity: null, price: null };
  }

  return {
    zone,
    quantity: data[zone].quantity,
    price: data[zone].price
  };
}